export const blockchainExplorerIntro = [
    {
      title: "¿Qué es un explorador de blockchain y por qué es fundamental saber utilizarlo?",
      value: `
  Un **explorador de blockchain** es una herramienta web que te permite visualizar y consultar toda la información pública de una blockchain en tiempo real.  
  Ejemplos populares incluyen [Etherscan](https://etherscan.io) para Ethereum, [Polygonscan](https://polygonscan.com) para Polygon, o [Solscan](https://solscan.io) para Solana.
  
  ---
  
  ### ¿Por qué es tan importante aprender a usar el explorador de cada red?
  
  - **Verificación y transparencia:** Puedes comprobar que tu contrato inteligente realmente fue desplegado en la red y que la transacción se completó correctamente.
  - **Auditoría pública:** Permite a cualquiera (usuarios, inversionistas o autoridades) revisar el código, las transacciones y los balances asociados a tu contrato.
  - **Seguimiento de actividad:** Puedes ver cuántos tokens se han movido, qué direcciones han interactuado con tu contrato y los eventos generados por el smart contract.
  - **Detección de errores:** Si algo no sale bien al desplegar o interactuar con tu contrato, puedes revisar los detalles de la transacción y los mensajes de error en el explorador.
  - **Herramienta universal:** Cada blockchain tiene su propio explorador, y es clave conocer el de la red que estás usando (por ejemplo, Etherscan para Ethereum, Polygonscan para Polygon, etc.).
  
  ---
  
  ### ¿Qué veremos de nuestro contrato en el explorador?
  
  - **Dirección de contrato:** Es la dirección única donde tu smart contract vive en la blockchain.
  - **Código fuente verificado:** Puedes subir y verificar tu código para que cualquiera lo consulte de forma transparente.
  - **Transacciones:** Se listan todas las interacciones con tu contrato, como transferencias de tokens, minting, o cambios de estado.
  - **Eventos y logs:** El explorador muestra los eventos emitidos por el contrato, útiles para seguimiento y debugging.
  - **Balances y holders:** Puedes consultar quiénes tienen tokens y cuántos.
  
  ---
  
  > **En resumen:**  
  Aprender a usar el explorador de cada red te da el control total sobre la verificación, transparencia y seguridad de tus desarrollos en blockchain. Es la forma más directa de comprobar que todo está funcionando como debe y de mostrar confianza a los usuarios e inversionistas.
  
  **En la práctica**, después de desplegar tu contrato, **buscaremos su dirección en el explorador correspondiente** (por ejemplo, Polygonscan para Polygon) y revisaremos cada uno de estos elementos.
  `
    }
  ];
  
  export default blockchainExplorerIntro;
  